import script from "./TalentPlat.vue?vue&type=script&lang=ts&setup=true"
export * from "./TalentPlat.vue?vue&type=script&lang=ts&setup=true"

import "./TalentPlat.vue?vue&type=style&index=0&id=1b81bd40&lang=scss&scoped.=true"

const __exports__ = script;

export default __exports__